import React, { useContext } from 'react';
import styled from 'styled-components';
import { ThemeContext } from 'context/themeContext';
import { useTranslation } from 'react-i18next';

const StyledDiv = styled.div`
  width: 20.822vw;
  height: 3.904vw;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
  margin-left:${(props) => props.rtlDirection ? '-2vw' : '9.5vw'};
  margin-top: 2vw;
`;

const StyledLine = styled.div`
  width: 16.303vw;
  height: 0.208vw;
  position: relative;
  background-color: ${(props) => props.theme.inputBackground};
`;

const StyledStatusLine = styled.div`
  height: 0.208vw;
  position: absolute;
  top: 0;
  left: 0;
  background-color: ${(props) => props.theme.tagBorder};
`;

const StyledCycle = styled.div`
  width: 0.989vw;
  height: 0.989vw;
  border-radius: 50%;
  background-color: ${(props) => props.theme.blueColorSecondary};
  position: absolute;
  top: -0.3905vw;
`;

const StyledTooltipContainer = styled.div`
  position: absolute;
  top: ${(props) => (props.top ? props.top : '-3.2vw')};
  left: ${(props) => (props.left ? props.left : 'calc(-5vw + 0.4945vw)')};
  width: 10vw;
  height: 2.2vw;
  display: flex;
  justify-content: center;
`;

const StyledTooltip = styled.div`
  position: relative;
  background-color: ${(props) => props.theme.borderBackground};
  color: ${(props) => props.theme.textPrimary};
  padding: 0.56vw;
  border-radius: 0.6vw;
  font-weight: bold;
  font-size: 0.78vw;
`;

const StyledTooltipArrow = styled.div`
  position: absolute;
  bottom: -0.56vw;
  right: calc(50% - 0.5vw);
  width: 0;
  height: 0;
  border-left: 0.56vw solid transparent;
  border-right: 0.56vw solid transparent;
  border-top: 0.56vw solid ${(props) => props.theme.borderBackground};
`;

const Stepper = (props) => {
  const { theme, rtlDirection } = useContext(ThemeContext);
  const { t } = useTranslation();
  const { status } = props;

  return (
    <StyledDiv rtlDirection={rtlDirection}>
      <StyledLine theme={theme}>
        <StyledStatusLine
          theme={theme}
          style={
            status === 1
              ? { width: '0vw' }
              : status === 2
                ? { width: '2.7661vw' }
                : status === 3
                  ? { width: '6.0267vw' }
                  : status === 4
                    ? { width: '9.2873vw' }
                    : status === 5
                      ? { width: '12.5479vw' }
                      : status === 6
                        ? { width: '15.8085vw' }
                        : {}
          }
        />
        <StyledCycle
          theme={theme}
          style={Object.assign(
            {},
            status < 1 ? { backgroundColor: theme.inputBackground } : {},
            status > 1 ? { backgroundColor: theme.tagBorder } : {},
            { left: '-0.4945vw' }
          )}
        >
          <StyledTooltipContainer theme={theme} style={status !== 1 ? { display: 'none' } : {}}>
            <StyledTooltip theme={theme}>
            {t('dashboard.table.status.Uncomplete')}
              <StyledTooltipArrow theme={theme} />
            </StyledTooltip>
          </StyledTooltipContainer>
        </StyledCycle>
        <StyledCycle
          theme={theme}
          style={Object.assign(
            {},
            status < 2 ? { backgroundColor: theme.inputBackground } : {},
            status > 2 ? { backgroundColor: theme.tagBorder } : {},
            { left: '2.7661vw' }
          )}
        >
          <StyledTooltipContainer theme={theme} style={status !== 2 ? { display: 'none' } : {}}>
            <StyledTooltip theme={theme}>
              {t('dashboard.table.status.Order registered')}
              <StyledTooltipArrow theme={theme} />
            </StyledTooltip>
          </StyledTooltipContainer>
        </StyledCycle>
        <StyledCycle
          theme={theme}
          style={Object.assign(
            {},
            status < 3 ? { backgroundColor: theme.inputBackground } : {},
            status > 3 ? { backgroundColor: theme.tagBorder } : {},
            { left: '6.0267vw' }
          )}
        >
          <StyledTooltipContainer theme={theme} style={status !== 3 ? { display: 'none' } : {}}>
            <StyledTooltip theme={theme}>
            {t('dashboard.table.status.Preparing for print')}
              <StyledTooltipArrow theme={theme} />
            </StyledTooltip>
          </StyledTooltipContainer>
        </StyledCycle>
        <StyledCycle
          theme={theme}
          style={Object.assign(
            {},
            status < 4 ? { backgroundColor: theme.inputBackground } : {},
            status > 4 ? { backgroundColor: theme.tagBorder } : {},
            { left: '9.2873vw' }
          )}
        >
          <StyledTooltipContainer theme={theme} style={status !== 4 ? { display: 'none' } : {}}>
            <StyledTooltip theme={theme}>
            {t('dashboard.table.status.Printing')}
              <StyledTooltipArrow theme={theme} />
            </StyledTooltip>
          </StyledTooltipContainer>
        </StyledCycle>
        <StyledCycle
          theme={theme}
          style={Object.assign(
            {},
            status < 5 ? { backgroundColor: theme.inputBackground } : {},
            status > 5 ? { backgroundColor: theme.tagBorder } : {},
            { left: '12.5479vw' }
          )}
        >
          <StyledTooltipContainer theme={theme} style={status !== 5 ? { display: 'none' } : {}}>
            <StyledTooltip theme={theme}>
            {t('dashboard.table.status.Packaging & Shipping')}
              <StyledTooltipArrow theme={theme} />
            </StyledTooltip>
          </StyledTooltipContainer>
        </StyledCycle>
        <StyledCycle
          theme={theme}
          style={Object.assign(
            {},
            status < 6 ? { backgroundColor: theme.inputBackground } : {},
            status > 6 ? { backgroundColor: theme.tagBorder } : {},
            { left: '15.8085vw' }
          )}
        >
          <StyledTooltipContainer theme={theme} style={status !== 6 ? { display: 'none' } : {}}>
            <StyledTooltip theme={theme}>
            {t('dashboard.table.status.Shipped')}
              <StyledTooltipArrow theme={theme} />
            </StyledTooltip>
          </StyledTooltipContainer>
        </StyledCycle>
      </StyledLine>
    </StyledDiv>
  );
};

export default Stepper;
